import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "customer-list" }
const _hoisted_2 = { class: "customer-search" }
const _hoisted_3 = { class: "card-container scroll-y" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "customer" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "contact" }
const _hoisted_8 = { class: "phone" }
const _hoisted_9 = { class: "email" }
const _hoisted_10 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        class: "g-search black",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
        type: "search",
        placeholder: "Search..."
      }, null, 512), [
        [_vModelText, $setup.searchQuery]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCustomers, (customer) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["wrapper", {active: $props.selectedUser?.$id === customer.$id}]),
          key: customer.$id,
          onClick: ($event: any) => (_ctx.$emit('update:selectedUser', customer))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              ((typeof customer.name === 'string'))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(customer.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(customer.name.firstName) + " " + _toDisplayString(customer.name.lastName), 1)
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(customer.phone), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(customer.email), 1)
            ])
          ])
        ], 10, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "secondary icon",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create-customer')))
      }, "Create New User")
    ])
  ]))
}